import Image from "next/image";
import Head from "next/head";
import styles from "./optional-test-series.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
// import Interest from "../../components/might-be-interest";
import crashcourse from "../../assets/images/home/Moksha/Moksha-2026-Web-Banner.jpg";
import Mobcrashcourse from "../../assets/images/home/Moksha/Moksha-2026-Mob-Banner.jpg";
import Link from "next/link";
import check from "../../assets/images/upsc/check.png";

const Two_Year_Classroom_Programme = () => {

    return (

        <>

        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index,follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />0
            <title>UPSC Optional Test Series 2025</title>
            <meta name="title" content="UPSC Optional Test Series 2025" />
            <meta name="description" content=" Join Shankar IAS Academy’s UPSC Optional Test Series 2025 for scheduled tests, expert reviews, and improved answer writing for Mains success." />
            <link rel="canonical" href="https://www.shankariasacademy.com/upsc-optional-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="UPSC Optional Test Series 2025" />
            <meta property="og:description" content="Join Shankar IAS Academy’s UPSC Optional Test Series 2025 for scheduled tests, expert reviews, and improved answer writing for Mains success." />
            <meta property="og:url" content="https://www.shankariasacademy.com/upsc-optional-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />

        </Head>

        <Navbar title="upsc" />
        
        <div className="container">

            <div className="row">
                <div className="col pt-3 pt-md-2">
                    <h1 className={`${styles.pagemaintitle}`}>UPSC Optional Test Series 2026</h1>
                </div>
            </div>

            <div className="row d-none d-md-block">
                <div className="col mb-3">
                    <Image
                        src={crashcourse}
                        alt="UPSC Mains Crash Course 2024"
                        title="UPSC Mains Crash Course 2024"
                        className="img-fluid w-100"
                    />
                </div>
          </div>

          <div className="row d-block d-md-none">
            <div className="col mb-3">
                <Image
                    src={Mobcrashcourse}
                    alt="UPSC Mains Crash Course 2024"
                    title="UPSC Mains Crash Course 2024"
                    className="img-fluid w-100"
                />
            </div>
          </div> 
        </div>


{/* table */}

  <section className="pt-3 pb-3" style={{background: "#F4F6F8 0% 0% no-repeat padding-box" , opacity: "1"}}>
        <div className="container-fluid">
           <div className="offset-xl-2 col-xl-8 ">   
           <div className="row">
                <div class=" col-12 col-md-12 col-xl-12 d-none d-md-block d-lg-block">
                         <table class="table table-striped">
                              <thead class="border-dark">
                                    <tr>
                                        <td className={`${styles.tableheading}`}>Optional Subject</td>
                                       {/* <td className={`${styles.tableheading}`}>Schedule 2024 <br/></td> */}
                                        <td className={`${styles.tableheading}`}>Schedule 2026 <br/></td>
                                        <td className={`${styles.tableheading}`}>Admission<br/></td>
                                    </tr>
                                </thead>
                               <tbody>

                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>PSIR</td>
                                        {/*  <td className={`${styles.tablepara}`}><Link href="https://www.shankariasacademy.com/pdf/moksha-mains/PSIR-Test-Batch-2024-Chennai.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></td>*/}
                                        <td className={`${styles.tablepara}`}><Link href="/upsc-psir-mains-test-series/"  target="_blank" className={`${styles.paybill}`}>Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Geography</td>
                                        <td className={`${styles.tablepara}`}><Link href="/upsc-geography-mains-test-series" target="_blank" className={`${styles.paybill}`}>Click Here</Link></td> 
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>English Literature</td>
                                        <td className={`${styles.tablepara}`}><Link href="#" target="_blank" className={`${styles.paybill}`}> Updated Soon</Link></td>
                                        {/* <td className={`${styles.tablepara}`}><Link href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/ENGLISH-OPTIONAL-TEST-SCHEDULE-2025.pdf" target="_blank" className={`${styles.paybill}`}> Click Here</Link></td> */}
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                    
                                    {/* <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Sociology</td>
                                      
                                        <td className={`${styles.tablepara}`}><Link href="/upsc-sociology-mains-test-series/"  target="_blank" className={`${styles.paybill}`}>Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank"><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                    <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Psychology</td>
                                        <td className={`${styles.tablepara}`}><Link href="/upsc-psychology-mains-test-series/" target="_blank" className={`${styles.paybill}`}>Click Here</Link></td>
                                       
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>


                                    <tr className="pt-2">
                                       <td className={`${styles.tablepara}`}>Public Administration</td>
                                       
                                        <td className={`${styles.tablepara}`}><Link href="/upsc-pubad-mains-test-series" target="_blank" className={`${styles.paybill}`}> Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                      <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>History</td> 
                                      
                                        <td className={`${styles.tablepara}`}><Link href="/upsc-history-mains-test-series" target="_blank" className={`${styles.paybill}`}> Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                       <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Agriculture</td>
                                     
                                        <td className={`${styles.tablepara}`}><Link href="/upsc-agriculture-mains-test-series" target="_blank" className={`${styles.paybill}`}>Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                   

                                       <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Economics</td>
                                        
                                        <td className={`${styles.tablepara}`}><Link href="/upsc-economics-mains-test-series" target="_blank" className={`${styles.paybill}`}>Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                 

                                     <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Anthropology</td>
                                        <td className={`${styles.tablepara}`}><Link href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/Anthropology/Anthropology-Test-Schedule-2025-Batch1.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>


                                     <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Mathematics</td>
                                       
                                        <td className={`${styles.tablepara}`}><Link href="/upsc-mathematics-mains-test-series" target="_blank"  className={`${styles.paybill}`}>Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>


                                  <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Law</td>
                                        <td className={`${styles.tablepara}`}><Link href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/Law/Law-Test-Schedule-2025-Batch1.pdf"  target="_blank" className={`${styles.paybill}`}>Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr>

                                     <tr className="pt-2">
                                        <td className={`${styles.tablepara}`}>Forestry</td>
                                        <td className={`${styles.tablepara}`}><Link href="/upsc-forestry-mains-test-series" target="_blank" className={`${styles.paybill}`}> Click Here</Link></td>
                                        <td className={`${styles.tablepara}`}><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></td>
                                    </tr> */}

                              
                              </tbody>
                        </table>
                        </div>
          
          
            </div>
            </div>
            </div>
</section>

        {/* Mobile View */}

<section className=" pb-3 d-md-none" style={{background: "" , opacity: "1"}}>
    <div className="container mt-2 mb-5">
        <div className="col-12 col-xl-12 ">   
        <div className="row">
     
        <div class=" col-12 col-xl-12 d-block d-md-none" style={{backgroundColor:"#f4f6f8"}}>
          <div class="py-2" style={{backgroundColor: "#001e62"}}><h2 className={`${styles.tabletitle}`}>UPSC Optional Test Series 2026</h2></div>
                <div class="row border-bottom">
					<div class={`${styles.tableheading} col-12 col-md-3 d-none d-md-block `}>Optional Subject</div>
					<div class={`${styles.tableheading} col-12 col-md-3 d-none d-md-block`}>Schedule 2024</div>
                    <div class={`${styles.tableheading} col-12 col-md-3 d-none d-md-block`}>Schedule 2026</div>
                    <div class={`${styles.tableheading} col-12 col-md-3 d-none d-md-block`}>Admission</div>		
				</div>

                <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Optional Subject</div>
                    <div class="col-6 pt-3 col-md-3"><b>PSIR</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Schedule  2026</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/upsc-psir-mains-test-series/" target="_blank" className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>

                 <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Optional Subject</div>
                    <div class="col-6 pt-3 col-md-3"><b>Geography</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Schedule  2026</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/upsc-geography-mains-test-series"  className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>

                  <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Optional Subject</div>
                    <div class="col-6 pt-3 col-md-3"><b>English Literature</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Schedule  2025</div>
                    {/* <div class="col-6 pt-3 col-md-3"><b><Link href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/ENGLISH-OPTIONAL-TEST-SCHEDULE-2025.pdf"  className={`${styles.paybill}`}>Click Here</Link></b></div> */}
                    <div class="col-6 pt-3 col-md-3"><b><Link href="#"  className={`${styles.paybill}`}>Updated Soon</Link></b></div> 
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>


                
            {/* 
                  <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Optional Subject</div>
                    <div class="col-6 pt-3 col-md-3"><b>Sociology</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Schedule 2025</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/upsc-sociology-mains-test-series/"  className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>


                 <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Optional Subject</div>
                    <div class="col-6 pt-3 col-md-3"><b>Psychology</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Schedule 2025</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/upsc-psychology-mains-test-series"  className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>

                   <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Optional Subject</div>
                    <div class="col-6 pt-3 col-md-3"><b>Public Administration</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Schedule 2025</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/upsc-pubad-mains-test-series" target="_blank" className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>

                 <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Optional Subject</div>
                    <div class="col-6 pt-3 col-md-3"><b>History</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Schedule  2025</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/upsc-history-mains-test-series" target="_blank" className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>

                 
                 <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Optional Subject</div>
                    <div class="col-6 pt-3 col-md-3"><b>Economics</b></div>
                     <div class="col-6 pt-3 d-block d-md-none">Schedule  2025</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/upsc-economics-mains-test-series"  className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>

                

                
                 <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Optional Subject</div>
                    <div class="col-6 pt-3 col-md-3"><b>Anthropology (Chennai)</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Schedule  2025</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/Anthropology/Anthropology-Test-Schedule-2025-Batch1.pdf" target="_blank" className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>


               


                <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Optional Subject</div>
                    <div class="col-6 pt-3 col-md-3"><b>Mathematics (First Timers)</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Schedule  2025</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/upsc-mathematics-mains-test-series"  className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>

                <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Optional Subject</div>
                    <div class="col-6 pt-3 col-md-3"><b>Agriculture (Chennai)</b></div>
                    
                    <div class="col-6 pt-3 d-block d-md-none">Schedule  2025</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/upsc-agriculture-mains-test-series" target="_blank" className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>

                <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Optional Subject</div>
                    <div class="col-6 pt-3 col-md-3"><b>Law</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Schedule  2025</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://www.shankariasacademy.com/pdf/Moksha-Mains-2026/Law/Law-Test-Schedule-2025-Batch1.pdf"  className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div>

                  <div className="row border-bottom pt-3 ">
                    <div class="col-6 pt-3 d-block d-md-none">Optional Subject</div>
                    <div class="col-6 pt-3 col-md-3"><b>Forestry</b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Click Here</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="/upsc-forestry-mains-test-series"  className={`${styles.paybill}`}>Click Here</Link></b></div>
                    <div class="col-6 pt-3 d-block d-md-none">Admission</div>
                    <div class="col-6 pt-3 col-md-3"><b><Link href="https://admissionsv1.shankariasacademy.com/" target="_blank" ><button className={`${styles.normalbutton}`} type="submit">Pay Here</button></Link></b></div>
                </div> */}


                  
                
                                  
	      </div>
        </div>
        </div>
        </div>
</section> 


        <Footer />                      
        </>
    )
}
export default Two_Year_Classroom_Programme
